'use strict';

module.exports = function module_validate_select(selector, invalidValue, errorContainerSelector, errorClass) {
	errorContainerSelector = errorContainerSelector || '.errorContainer';
	errorClass = errorClass || 'error';
	invalidValue = invalidValue || '';

	var error = false;
	window.jQuery(selector).each(function forEachField() {
		var $this = window.jQuery(this);
		//you can't require an invisible select field
		if ($this.is(':visible')) {
			if ($this.val() === invalidValue || $this.val() === null) {
				$this.closest(errorContainerSelector).addClass(errorClass);
				error = true;
			} else {
				$this.closest(errorContainerSelector).removeClass(errorClass);
			}
		}
	});
	return error;
};
